import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './Home';
import Category from './Components/Category/Category';
import Admin from './Components/Admin/Admin';
import AudioCulture from './Components/AudioCulture/AudioCulture';
import WineFlavorMap from './Components/WineFlavorMap/WineFlavorMap';
import CocktailFlavorMap from './Components/CocktailFlavorMap/CocktailFlavorMap';

function App() {
  return (
    <Router>
    <div className="App">
      {/* Aquí están las rutas de la aplicación */}
      <Routes>
        {/* Sin landing: el QR y la raiz caen directo en el indice del menu.
            /Inicio se mantiene como redireccion por si quedan QR o enlaces viejos. */}
        <Route path="/" element={<Navigate to="/Home" replace />} />
        <Route path="/Inicio" element={<Navigate to="/Home" replace />} />
        <Route path="/Home" element={<Home />} /> {/* Ruta para el menú */}
        <Route path="/Category/:id/mapa" element={<WineFlavorMap />} />
        <Route path="/Category/:id/cocteles" element={<CocktailFlavorMap />} />
        <Route path="/Category/:id" element={<Category />} /> {/* Ruta para Categorias Filtradas */}
        <Route path="/AudioCulture" element={<AudioCulture />} /> {/* Ruta para Audio Culture */}
        <Route path="/admin" element={<Admin />} /> {/* Ruta de administración - NO visible para clientes */}
      </Routes>
    </div>
  </Router>
  );
}

export default App;
